import mercat from '~assets/channels/mercat-channel.png';
import uberEats from '~assets/channels/uberEats-channel.png';
import rappi from '~assets/channels/rappi-channel.png';
import pedidosYa from '~assets/channels/peyaAggregator-channel.png';
import amipass from '~assets/channels/amipass-channel.png';
import didi from '~assets/channels/didi-channel.png';

export const MERCAT_CHANNEL = 'mercat';
export const UBER_EATS_CHANNEL = 'uberEats';
export const RAPPI_CHANNEL = 'rappi';
export const PEDIDOS_YA_CHANNEL = 'peyaAggregator';
export const AMIPASS_CHANNEL = 'amipass';
export const DIDI_CHANNEL = 'didi';

export const CHANNEL_ICONS = {
  [MERCAT_CHANNEL]: {
    icon: mercat,
    appName: 'mercat'
  },
  [UBER_EATS_CHANNEL]: {
    icon: uberEats,
    appName: 'appUberEats'
  },
  [RAPPI_CHANNEL]: {
    icon: rappi,
    appName: 'appRappi'
  },
  [PEDIDOS_YA_CHANNEL]: {
    icon: pedidosYa,
    appName: 'appPedidosYa'
  },
  [AMIPASS_CHANNEL]: {
    icon: amipass,
    appName: 'appAmipass'
  },
  [DIDI_CHANNEL]: {
    icon: didi,
    appName: 'appDidi'
  }
};
